module.exports = __webpack_public_path__ + "img/map.60844c5b.svg";